import BarraMenu from "../../../components/BarraMenu";
import PageHero from "../../../components/PageHero";
import useDigitalTheme from "../../hooks/useDigitalTheme";
import { Accordion } from "react-bootstrap";
import { FaClipboardCheck } from "react-icons/fa";
import FormularioPropiedadesClientes from "./FormularioPropiedadesClientes";
import FormularioPropiedadesUserJob from "./FormularioPropiedadesUserJob";
import "./style.css";

const AdministracionParametrosPage = () => {
  useDigitalTheme();
  return (
    <div className="params-page page-shell">
      <BarraMenu />
      <div className="page-shell__body">
        <PageHero
          icon={<FaClipboardCheck />}
          title="Parámetros del sistema"
          subtitle="Configuración de clientes, cargos y propiedades del sistema"
        />

        {/* 1. CLIENTES */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>CLIENTES</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesClientes />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* 2. CARGOS */}
        <Accordion className="mb-4" defaultActiveKey={["0"]} alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>CARGOS</Accordion.Header>
            <Accordion.Body>
              <FormularioPropiedadesUserJob />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

      </div>
    </div>
  );
};

export default AdministracionParametrosPage;
